import { ComponentProps } from 'react';

import { cx } from '@libs/classnames';

import styles from './FancyPanel.module.css';

export type FancyPanelActionProps = {
  size?: 'small' | 'medium';
} & ComponentProps<'button'>;

export function FancyPanelAction({ size = 'medium', className, ...rest }: FancyPanelActionProps) {
  return <button className={cx(styles.action, styles[`size_${size}`], className)} {...rest} />;
}
